<div *ngIf="loader" class="container" id="spinerLoader">
  <div class="loader">Loading...</div>
</div>

<div>
  <section class="content-header row">
    <div class="col-md-12 box-header">
      <h2 class="box-title">
        <strong>Manage Data</strong>
      </h2>
      <div class="pull-right box-tools">
      </div>
    </div>
  </section>
  <section class="content footerPosition">
    <div class="row">

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class="card-layout card" id="Location-List">
          <h4 class='my-0'>Location</h4>
          <hr class="hr-class mb-3" />
          <div class='d-flex'>
            <div
              [style.width]="(isInternalReadOnly || IsObjectNull(mapOriginDataModel.locationSelected)) || user.role == roleName.Accounting ? '100%' : 'calc(100% - 80px)'">
              <ngx-select-dropdown tabindex="0" [multiple]="false" (click)="clickDropDown('locationSelect');"
                id="locationSelect" name="originDropDown" [(ngModel)]="mapOriginDataModel.locationSelected"
                [options]="mapOriginDataModel.serviceLocations" [config]="mapOriginDataModel.mapOriginConfig"
                (change)="changeLocation($event)">
              </ngx-select-dropdown>
            </div>
            <div *ngIf="!isInternalReadOnly" class="d-flex">
              <ng-container *ngIf="user.role != roleName.Accounting">
                <button *ngIf="!IsObjectNull(mapOriginDataModel.locationSelected)" type="button" id="editLocationButton"
                  data-target="#addLocation" data-toggle="modal" class="add-delete-button ml-3"
                  title="Edit Location Name" (click)="checkForAirportLocation(mapOriginDataModel.locationSelected)">
                  <i class="fa fa-edit fa-lg"></i>
                </button>
              </ng-container>
              <button *ngIf="user.role != 'Coordinator'" type="button" id="deleteLocationButton" (click)="deleteSelectedLocation()"
                class="add-delete-button" title="Delete Location">
                <i class="fa fa-minus-circle fa-lg"></i>
              </button>
              <button type="button" id="disableLocationButton" (click)="disableSelectedLocation()"
                class="add-delete-button" title="Disable Location">
                <i class="fa fa-ban fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="user.role == roleName.Accounting" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class="card-layout card" id="Display-Name-List">
          <h4 class='my-0'>Display Name</h4>
          <hr class="hr-class mb-3" />
          <div class='d-flex'>
            <div class="w-100 pr-3">
              <input type="text" class="form-control" id="display-name" [(ngModel)]="locationDisplayName"
                placeholder="Display Name">
            </div>
            <div>
              <button type="button" id="save-display-name"
                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                (click)="addDisplayName()" [disabled]="!locationDisplayName">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="user.role!=roleName.Accounting" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class="card-layout card" id="Equipment-List">
          <h4 class='my-0'>Equipment</h4>
          <hr class="hr-class mb-3" />
          <div class="d-flex">
            <div class="w-100">
              <ngx-select-dropdown *ngIf="!isShowAddEquipment" tabindex="0" [multiple]="false" id="equipmentSelect"
                (click)="clickDropDown('equipmentSelect')" [(ngModel)]="equipmentDataModel.selectedEquipment"
                name="equipType" [config]="equipmentDataModel.EquipmentSetting"
                [options]="equipmentDataModel.equipmentTypes" [ngModelOptions]="{standalone: true}">
              </ngx-select-dropdown>
              <input *ngIf="isShowAddEquipment" type="text" name="addEquipmentType" class="form-control"
                placeholder="Equipment Type" [(ngModel)]="addEquip.equipmentType">
            </div>
            <div *ngIf="!isShowAddEquipment && !isInternalReadOnly && user.role != 'Coordinator'" class='d-flex'>
              <button type="button" id="addEquipmentButton" (click)="isShowAddEquipment=true" class="add-delete-button"
                title="Add Equipment Type">
                <i class="fa fa-plus-circle fa-lg"></i>
              </button>
              <button type="button" id="deleteEquipmentButton" (click)="deleteJobType(serviceType.equipment)"
                class="add-delete-button" title="Delete Equipment Type"><i class="fa fa-minus-circle fa-lg"></i>
              </button>
            </div>
            <div *ngIf="isShowAddEquipment" class='ml-2'>
              <button type="button" id="addAddEquipmentButton"
                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14 mt-1"
                (click)="isShowAddEquipment = false; addJobType(serviceType.equipment)">Add</button>
            </div>
            <div *ngIf="isShowAddEquipment" class="ml-2 mt-1">
              <button type="button" id="cancelAddEquipmentButton" (click)="clearData(serviceType.equipment)"
                class="add-delete-button" title="Cancel Add Equipment Type">
                <i class="fa fa-times-circle fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class='row'>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class='card-layout card' id="Organ-List">
          <h4 class='my-0'>Organ</h4>
          <hr class="hr-class mb-3" />
          <div class="d-flex">
            <div class="w-100">
              <ngx-select-dropdown *ngIf="!isShowAddOrgan" tabindex="0" [multiple]="false" id="OrganSelect"
                (click)="clickDropDown('OrganSelect')" [(ngModel)]="organDataModel.selectedOrgan" name="organType"
                [config]="organDataModel.OrganSetting" [options]="organDataModel.organTypes"
                [ngModelOptions]="{standalone: true}">
              </ngx-select-dropdown>
              <input *ngIf="isShowAddOrgan" type="text" name="addOrganType" class="form-control"
                placeholder="Organ Type" [(ngModel)]="addEquip.equipmentType">
            </div>
            <div *ngIf="!isShowAddOrgan && !isInternalReadOnly && user.role != 'Coordinator'" class="d-flex">
              <button type="button" id="addOrganButton" (click)="isShowAddOrgan=true" class="add-delete-button"
                title="Add Organ Type">
                <i class="fa fa-plus-circle fa-lg"></i>
              </button>
              <button type="button" id="deleteOrganButton" (click)="deleteJobType(serviceType.organ)"
                class="add-delete-button" title="Delete Organ Type">
                <i class="fa fa-minus-circle fa-lg"></i>
              </button>
            </div>
            <div *ngIf="isShowAddOrgan" class="ml-2">
              <button type="button" id="addAddOrganButton"
                class="flat-butt flat-info-butt flat-info-grad-butt w-100 font-size-14 save-btn mt-1"
                (click)="isShowAddOrgan = false; addJobType(serviceType.organ)">
                Add
              </button>
            </div>
            <div *ngIf="isShowAddOrgan" class="ml-2 mt-1">
              <button type="button" id="cancelAddOrganButton" (click)="clearData(serviceType.organ)"
                class="add-delete-button" title="Cancel Add Organ Type">
                <i class="fa fa-times-circle fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class="card-layout card" id="Specimen-List">
          <h4 class='my-0'>Specimen</h4>
          <hr class="hr-class mb-3" />
          <div class="d-flex">
            <div class="w-100">
              <ngx-select-dropdown *ngIf="!isShowAddSpecimen" tabindex="0" [multiple]="false" id="specimenSelect"
                (click)="clickDropDown('specimenSelect')" [(ngModel)]="specimenDataModel.selectedSpecimen"
                name="specimenType" [config]="specimenDataModel.SpecimenSetting"
                [options]="specimenDataModel.specimenTypes" [ngModelOptions]="{standalone: true}">
              </ngx-select-dropdown>
              <input *ngIf="isShowAddSpecimen" type="text" name="addSpecimenType" class="form-control"
                placeholder="Specimen Type" [(ngModel)]="addEquip.equipmentType">
            </div>
            <div *ngIf="!isShowAddSpecimen && !isInternalReadOnly && user.role != 'Coordinator'" class="d-flex">
              <button type="button" id="addSpecimenButton" (click)="isShowAddSpecimen=true" class="add-delete-button"
                title="Add Specimen Type">
                <i class="fa fa-plus-circle fa-lg"></i>
              </button>
              <button type="button" id="deleteSpecimenButton" (click)="deleteJobType(serviceType.specimen)"
                class="add-delete-button" title="Delete Specimen Type"><i class="fa fa-minus-circle fa-lg"></i>
              </button>
            </div>
            <div *ngIf="isShowAddSpecimen" class="ml-2">
              <button type="button" id="addAddSpecimenButton"
                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14  mt-1"
                (click)="isShowAddSpecimen = false; addJobType(serviceType.specimen)">Add</button>
            </div>
            <div *ngIf="isShowAddSpecimen" class="ml-2 mt-1">
              <button type="button" id="cancelAddSpecimenButton" (click)="clearData(serviceType.specimen)"
                class="add-delete-button" title="Cancel Add Specimen Type">
                <i class="fa fa-times-circle fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class='row'>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class='card-layout card' id="State-List">
          <h4 class='my-0'>State</h4>
          <hr class="hr-class mb-3" />
          <div>
            <ngx-select-dropdown tabindex="0" [multiple]="false" id="stateSelect"
              (change)="getCityListBasedOnSelectedState($event)" name="state" [config]="stateDataModel.StateSetting"
              [options]="stateDataModel.stateList" (click)="clickDropDown('stateSelect')">
            </ngx-select-dropdown>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class="card-layout card" id="City-List">
          <div class="d-flex">
            <h4 class='my-0'>City</h4>
            <span>
              <i *ngIf="editCity == true" class="fa fa-spin fa-spinner text-color font-size-14 ml-2"></i>
            </span>
          </div>
          <hr class="hr-class mb-3" />
          <div class="d-flex">
            <div class="w-100">
              <ngx-select-dropdown *ngIf="!isShowAddCityOption" tabindex="0" [multiple]="false"
                [(ngModel)]="cityDataModel.selectedCity" name="city" id="citySelect"
                [config]="cityDataModel.CitySetting" [options]="cityDataModel.cityList"
                (click)="clickDropDown('citySelect')">
              </ngx-select-dropdown>
              <input *ngIf="isShowAddCityOption" type="text" name="addSpecimenType" class="form-control"
                placeholder="Enter City Name" [(ngModel)]="cityAdd.cityName">
            </div>
            <div *ngIf="isStateSelected == true && isShowAddCityOption == false && !isInternalReadOnly" class="d-flex">
              <button type="button" id="addCity" class="add-delete-button" title="Add City"
                (click)="isShowAddCityOption = true">
                <i class="fa fa-plus-circle fa-lg"></i>
              </button>
              <button type="button" id="deleteCity" class="add-delete-button" title="Delete City"
                (click)="deleteCity()">
                <i class="fa fa-minus-circle fa-lg"></i>
              </button>
            </div>
            <div *ngIf="isShowAddCityOption == true" class="ml-2">
              <button type="button" id="addAddCity"
                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14  mt-1"
                (click)="isShowAddCityOption=false; addCity()">
                Add
              </button>
            </div>
            <div *ngIf="isShowAddCityOption == true" class="ml-2 mt-1">
              <button type="button" id="cancelAddSpecimenButton" (click)="isShowAddCityOption=false; clearCityData()"
                class="add-delete-button" title="Cancel Add City">
                <i class="fa fa-times-circle fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="user.role != roleName.Accounting" class="row">

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div class='card-layout card' id="Additional-Equipment-List">
          <h4 class='my-0'>Additional Equipment Types</h4>
          <hr class="hr-class mb-3" />
          <div class="d-flex">
            <div class="w-100">
              <ngx-select-dropdown *ngIf="!isShowAddAdditionalEquipmentType" tabindex="0" [multiple]="false"
                id="addAdditionalEquipmentType" (click)="clickDropDown('addAdditionalEquipmentType')"
                [(ngModel)]="additionalEquipmentDataModel.selectedAdditionalEquipmentType"
                name="addAdditionalEquipmentType"
                [config]="additionalEquipmentDataModel.additionalEquipmentDropdownSetting"
                [options]="additionalEquipmentDataModel.additionalEquipmentTypeList"
                [ngModelOptions]="{standalone: true}">
              </ngx-select-dropdown>
              <input *ngIf="isShowAddAdditionalEquipmentType" type="text" name="addAdditionalEquipmentTypeInput"
                class="form-control" placeholder="Add New Additional Equipment Type"
                [(ngModel)]="addEquip.equipmentType">
            </div>
            <div *ngIf="!isShowAddAdditionalEquipmentType && !isInternalReadOnly" class="d-flex">
              <button type="button" id="addAdditionalEquipmentTypeButton"
                (click)="isShowAddAdditionalEquipmentType=true" class="add-delete-button"
                title="Add Additional Equipment Type">
                <i class="fa fa-plus-circle fa-lg"></i>
              </button>
              <button type="button" id="deleteAdditionalEquipmentType" (click)="deleteAdditionalEquipmentType()"
                class="add-delete-button" title="Delete Additional Equipment Type">
                <i class="fa fa-minus-circle fa-lg"></i>
              </button>
            </div>
            <div *ngIf="isShowAddAdditionalEquipmentType" class="ml-2">
              <button type="button" id="closeAddAdditionalEquipmentType"
                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14  mt-1"
                (click)="isShowAddAdditionalEquipmentType = false; addAdditionalEquipmentType()">
                Add
              </button>
            </div>
            <div *ngIf="isShowAddAdditionalEquipmentType" class="ml-2 mt-1">
              <button type="button" id="cancelAddAdditionalEquipmentType"
                (click)="isShowAddAdditionalEquipmentType=false" class="add-delete-button"
                title="Cancel Add Additional Equipment Type">
                <i class="fa fa-times-circle fa-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </section>
</div>



<div class="modal" id="addLocation">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close"><i
            class="fa fa-close"></i></button>
        <h4 class="modal-title">Edit Location</h4>
      </div>

      <form *ngIf="mapOriginDataModel.locationSelected != undefined" name="addLocationForm" #addLocationForm="ngForm">
        <div class="modal-body">

          <div class="member-card">
            <h4 class="filter-options">Address Details</h4>
            <hr class="hr-class" />
            <div class="col-md-12">
              <div class="row form-group">
                <label>Location Name</label><span class="text-danger"> * </span>

                <input type="text" name="addressName" #addressName="ngModel" id="addressName"
                  [(ngModel)]="mapOriginDataModel.locationSelected.locationName" placeholder="Location Name"
                  class="form-control" maxlength="255"
                  [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressName.invalid }" required />
                <div *ngIf="addLocationForm.submitted && addressName.invalid" class="invalid-feedback">
                  <div *ngIf="addressName.errors.required"><span class="text-danger">Location Name is required.</span>
                  </div>
                </div>
              </div>

            </div>

            <div class="row form-group">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Address Type</label><span class="text-danger"> * </span>
                <select name="addressType" #addressType="ngModel" class="form-control" id="addressType"
                  [(ngModel)]="mapOriginDataModel.locationSelected.locationAddressType"
                  [ngClass]="{ 'is-invalid': addLocationForm.submitted && addressType.invalid }" required>
                  <option [value]="undefined" selected disabled>Select Address Type</option>
                  <option *ngFor="let address of AddressType" [value]="address" name="address_type">
                    {{address}}
                  </option>
                </select>
                <div *ngIf="addLocationForm.submitted && addressType.invalid" class="invalid-feedback">
                  <div *ngIf="addressType.errors.required"><span class="text-danger">Address Type is
                      required.</span></div>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Address</label><span class="text-danger"> * </span>
                <div class="radio my-0">
                  <label>
                    <input type="radio" name="isGlobal" #pvtOrPublic="ngModel"
                      [(ngModel)]="mapOriginDataModel.locationSelected.isGlobal" [value]="false" />Private
                  </label>
                  <label class="ml-4">
                    <input type="radio" name="isGlobal" #pvtOrPublic="ngModel"
                      [(ngModel)]="mapOriginDataModel.locationSelected.isGlobal" [value]="true" />Public
                  </label>
                  <label class="ml-4">
                    <input type="radio" name="isGlobal" #pvtOrPublic="ngModel"
                      [(ngModel)]="mapOriginDataModel.locationSelected.isGlobal" [value]="null" />Airport
                  </label>
                </div>
              </div>
            </div>

            <div *ngIf="mapOriginDataModel.locationSelected.isGlobal == null" class="row form-group">
              <div class="col-md-6">
                <label>Airport Code </label><span class="text-danger"> * </span>
                <button *ngIf="!isShowAddAirportCode" type="button" id="addAirportCode"
                  (click)="isShowAddAirportCode = true" class="plus-icon" title="Add Airport Code">
                  <i class="fa fa-plus-circle "></i>
                </button>
                <button *ngIf="isShowAddAirportCode" type="button" class="plus-icon" title="Cancel Add Airport Code"
                  (click)="isShowAddAirportCode = false; airport=''">
                  <i class="fa fa-times-circle"></i>
                </button>
                <div *ngIf="isShowAddAirportCode">
                  <div class="col-md-8 px-0">
                    <input type="text" class="form-control" placeholder="Enter Airport Code" name="airportCode"
                      id="airport-code" #airportCode="ngModel" [(ngModel)]="airport" [value]="airport | uppercase"
                      maxlength="4" required>
                  </div>
                  <div class="col-md-4 pr-0">
                    <button class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                      id="save-airport-code" type="submit" (click)="isShowAddAirportCode = false; addAirportCode()">
                      Save
                    </button>
                  </div>
                </div>
                <select *ngIf="!isShowAddAirportCode" name="airportCode" #airportCode="ngModel" class="form-control"
                  id="select-airport-code" [(ngModel)]="mapOriginDataModel.locationSelected.airportCode"
                  [ngClass]="{ 'is-invalid': addLocationForm.submitted && airportCode.invalid }" required>
                  <option [value]="null" selected disabled>Select Airport Code</option>
                  <option *ngFor="let item of airportCodeList" [value]="item.airportCode" name="state">
                    {{item?.airportCode}}
                  </option>
                </select>
                <!--todo commented as no details for airportCode-->
                <!--<div *ngIf="addLocationForm.submitted && airportCode && airportCode.invalid" class="invalid-feedback">
                  <div *ngIf="airportCode.errors.required">
                    <span class="text-danger">
                      Airport Code is required.
                    </span>
                  </div>
                </div>-->
              </div>
            </div>

            <div class="row form-group">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Street Address</label><span class="text-danger"> * </span>
                <input type="text" name="streetAddress" #streetAddress="ngModel" id="aContact_StreetAddress"
                  [(ngModel)]="mapOriginDataModel.locationSelected.streetAddress" placeholder="Street Address"
                  class="form-control" disabled />
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>ZipCode</label><span class="text-danger"> * </span>
                <input type="text" class="form-control" id="ZipCode" placeholder="ZipCode" name="ZipCode"
                  #ZipCode="ngModel" [(ngModel)]="mapOriginDataModel.locationSelected.zipCode" disabled />
                <div *ngIf="addLocationForm.submitted && ZipCode.invalid" class="invalid-feedback">
                  <div *ngIf="ZipCode.errors.pattern">
                    <span class="text-danger">ZipCode not valid.</span>
                  </div>
                  <div *ngIf="ZipCode.errors.minlength">
                    <span class="text-danger">ZipCode must have 3 or 5 digits.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>State </label><span class="text-danger"> * </span>
                <input type="text" class="form-control" id="state" placeholder="State" name="state" #State="ngModel"
                  [(ngModel)]="mapOriginDataModel.locationSelected.state" disabled />
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>City </label><span class="text-danger"> * </span>
                <input type="text" class="form-control" id="city" placeholder="City" name="city" #City="ngModel"
                  [(ngModel)]="mapOriginDataModel.locationSelected.city" disabled />
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
            id="cancel-edit-location" data-dismiss="modal">Cancel</button>
          <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn" id="edit-location"
            (click)="editSelectedLocationName(addLocationForm)">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
